import { isNativePlatform } from "@/native/platform";
import type React from "react";
import { useFullAppOverride } from "./fullAppOverride";
import { MobileHomeSurface } from "./MobileHomeSurface";

/**
 * Element for `/`. On native this renders the focused mobile home as a
 * full-screen overlay (see {@link MobileScreen}) on top of whichever full-app
 * home was passed in, unless the user chose "Open full app" (a session flag,
 * observed reactively so the tap re-renders this gate in place).
 *
 * `fullApp` is the layout's own home element — `WorkspaceIndexPage`.
 *
 * A client-side redirect to `/m` here races the app's load/auth cycle and can
 * bounce, so we render in place instead. The `/m` route still renders the
 * mobile home directly for deep links and the drawer entry.
 */
export function HomeGate({ fullApp }: { fullApp: React.ReactNode }) {
  const fullAppOverride = useFullAppOverride();
  if (isNativePlatform() && !fullAppOverride) {
    return <MobileHomeSurface />;
  }
  return <>{fullApp}</>;
}

export default HomeGate;
